// extracted by css-extract-rspack-plugin
export default {"formContainer":"AuthView_formContainer__Crnb0","form":"AuthView_form__Z4AOv","loginText":"AuthView_loginText__ezyXY","loginPageContainer":"AuthView_loginPageContainer__RrRtL"};